<script>import TimeSeriesPlot from "../../d3/TimeSeriesPlot.svelte";
export let plotDefinitions;
export let startMarker = void 0;
export let endMarker = void 0;
</script>

<div>
  <TimeSeriesPlot
  role={"plot"}
  showAxis={true}
  separate={true}
  bind:startMarker
  bind:endMarker>
  {#each plotDefinitions as plotDefinition}
  <svelte:component this={plotDefinition.type} {...plotDefinition.properties}  />
  {/each}
</TimeSeriesPlot>
</div>
